import React, { useEffect } from "react";
import FaqHome from "app/pages/Faq/FaqHome/FaqHome";
import { sendTagOnFaqHomePage } from "app/utils/analytics";

const FaqHomeContainer = props => {
	useEffect(() => {
		sendTagOnFaqHomePage();
	}, []);

	return <FaqHome {...props} />;
};

FaqHomeContainer.propTypes = {};

export default FaqHomeContainer;
